import React from 'react';
import SpinKitCube from './SpinKitCube';

function QueryResultRunning() {
  return (
    <div className="h-100 flex-center">
      <SpinKitCube />
    </div>
  );
}

export default QueryResultRunning;
